import { Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-start-survey-using-manual-data-selection',
  templateUrl: './start-survey-using-manual-data-selection.component.html',
  styleUrls: ['./start-survey-using-manual-data-selection.component.scss']
})
export class StartSurveyUsingManualDataSelectionComponent implements OnInit, IDialogView {
  data: DialogModel;
  survey: any;
  selectedFieldSectionIndex: number;
  selectedSection: any;
  invalidateSubject: InvalidateSubject;
  invalidateSubjectEntityChart: InvalidateSubject;
  invalidateSubjectEntityTracker: InvalidateSubject;
  invalidateSubjectTransaction: InvalidateSubject;
  constructor() {
    this.invalidateSubject = new InvalidateSubject();
    this.invalidateSubjectEntityChart = new InvalidateSubject();
    this.invalidateSubjectEntityTracker = new InvalidateSubject();
    this.invalidateSubjectTransaction = new InvalidateSubject();
   }

  ngOnInit() {
    if (this.data && this.data.input) {
      this.survey = this.data.input.survey;
      if (this.survey && this.survey.dataSections) {
        this.onTabIndexChange(0);
      }
    }
  }

  onOkClicked(): boolean {
    return true;
  }

  onTabIndexChange(event) {
    this.selectedFieldSectionIndex = event;
    this.selectedSection = this.survey.dataSections[event];
  }
}
